// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"164":"95631e9b","312":"233ea0f6","508":"c9a1e92a","588":"b01a1566"}[chunkId] + ".css";
};